<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        Collection Activity
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.nokontrak"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tgl.Buka</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tglkontrak" type="date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.debitur_name" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.penggunaan" disabled></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.modelkredit=='PAB'">
                <label>Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label>Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.modelkredit=='PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.interest"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.modelkredit=='PAB'">
              <b-input-group-prepend>
                <label>Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.angsuran"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.interestod"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-card border-variant="info" header="Detail Info " align="center" no-body>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          small
          style="font-size:smaller;"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusy"
          show-empty
        >
          <template v-slot:cell(index)="data">{{data.index +1}}</template>
          <template v-slot:cell(modified)="data">{{data.item.modified | moment('YYYY-MM-DD HH:mm')}}</template>
          <template v-slot:cell(photo)="data">
            <b-img style="max-height:300px" thumbnail fluid :src="data.item.photo" alt="Thumbnail" />
            <b-row align-h="center" class="mt-2">
              <b-col>
                <b-button @click="detailImage(data.item)"><i class="fa fa-eye"></i>  Detail</b-button>
              </b-col>
            </b-row>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
          </b-col>
          <b-col cols="4">
            <b-form-group label-cols="3" label style="margin-top:0 !important;">
              <b-input-group>
                <b-input-group-prepend class="mr-2">
                  <label>Limit per page</label>
                </b-input-group-prepend>
                <div class="d-flex">
                  <b-form-select
                    :options="[10, 15, 20, 25]"
                    :plain="true"
                    v-model="tblData.limit"
                    size="sm"
                    style="width:80px"
                  />
                </div>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
        <!-- <b-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</b-card-text> -->
      </b-card>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showDetailImage" title="Detail Image">
      <GmapMap :center="detailImg.center" :map-type-id="detailImg.mapTypeId" :zoom="15">
        <GmapMarker
          v-for="(item, index) in detailImg.markers"
          :key="index"
          :position="item.position"
          @click="center = item.position"
        />
      </GmapMap>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.vue-map-container {
  height: 450px;
  max-width: 992px;
  width: 100%;
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuPinjaman from "./lkuPinjaman";
import kolektor from "../../apis/kolektorkredit";
// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  requiredUnless,
  minValue,
  minLength,
  numeric,
} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
    },
  },
  data() {
    return {
      model: { pinjamankey: "" },
      lkuPinjamanShow: false,
      tblData: {
        page: 1,
        items: [],
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
      },
      isBusy: false,
      showDetailImage: false,
      detailImg: {
        center: { lat: 0, lng: 0 },
        mapTypeId: "terrain",
        markers: [
          { position: { lat: 0, lng: 0 } }
        ],
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        { key: "index", label: "#" },
        {
          key: "photo",
          label: "Photo",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
        },

        {
          key: "activity_update",
          label: "Activity",
          thClass: "text-center",
          thStyle: "width:500px",
        },
        {
          key: "modified",
          label: "Tanggal Update",
          thClass: "text-center",
          thStyle: "width:500px",
        },
      ];
      return fields;
    },
  },
  created: async function () {
    if (this.$route.params.pinjamankey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        const sampleData = [
          {
            pinjamankey: "1",
            nokontrak: "MF-1808-71238312",
            tglkontrak: "2018-08-17",
            debitur_name: "EKO SENO SETIADJI",
            modelkredit: "PAB",
            penggunaan: "Pembelian Mobil Honda CRV 2018",
            interest: 14.6,
            tenor: 36,
            principal: 400000000,
            installment_amount: 13787906.98,
            koletibilitas: "KOL-1",
            final: 1,
            cair: 1,
            matauang: "IDR",
          },
          {
            pinjamankey: "2",
            nokontrak: "MF-2006-71238312",
            tglkontrak: "2015-05-07",
            debitur_name: "SIGIT ARIANTO",
            modelkredit: "PAB",
            penggunaan: "Pembelian Rumah Sentul City",
            interest: 14.6,
            tenor: 120,
            principal: 500000000,
            installment_amount: 6355768.43,
            koletibilitas: "KOL-1",
            final: 1,
            cair: 1,
            matauang: "IDR",
          },
          {
            pinjamankey: "3",
            nokontrak: "MF-2020-71238312",
            tglkontrak: "2020-07-17",
            debitur_name: "RIO SAPUTRA",
            modelkredit: "PAB",
            penggunaan: "Pembelian Motor Honda PCX 2020",
            interest: 14.6,
            tenor: 36,
            principal: 30000000,
            installment_amount: 1034093.02,
            koletibilitas: "",
            final: 0,
            cair: 0,
            matauang: "IDR",
          },
          {
            pinjamankey: "4",
            nokontrak: "MF-2002-20022002",
            tglkontrak: "2020-02-02",
            debitur_name: "DONNY ARISTA",
            modelkredit: "PRK",
            penggunaan: "MODAL KERJA PT. GLOSTECH",
            interest: 20,
            interestod: 40,
            tenor: 24,
            principal: 1000000000,
            koletibilitas: "KOL-1",
            final: 0,
            cair: 0,
            matauang: "IDR",
          },
        ];
        const row = sampleData.find(
          (ds) => ds.pinjamankey == this.$route.params.pinjamankey
        );

        row.tglkontrak = row.tglkontrak
          ? moment(row.tglkontrak).format("YYYY-MM-DD")
          : "";
        for (var key in row) {
          this.model[key] = row[key];
        }

        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      // const [a,c,d,e] = await Promise.all([arpayment.currency(),await arpayment.argroup(),await arpayment.potongan(),
      //                 crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false})]) ;
      // this.currency = a;
      // this.arGroups = c;
      // this.potongans = d;
      //     this.collectors = e.reduce((newArr,item) =>{
      //         newArr.push({ value: item.collector_id, text: item.collector_name});
      //         return newArr;
      //     },[]);
    }
  },
  methods: {
    onSelectLkuPinjaman(_selected) {
      this.model.pinjamankey = _selected.pinjamankey;
      this.model.nasabahkey = _selected.nasabahkey;
      this.model.nokontrak = _selected.no_kontrak;
      this.model.tglkontrak = _selected.tgl_kontrak
        ? moment(_selected.tgl_kontrak).format("YYYY-MM-DD")
        : "";
      this.model.debitur_name = _selected.CustName;
      this.model.penggunaan = _selected.uraian;
      this.model.modelkredit = _selected.model_pinjaman;
      this.model.matauang = _selected.matauang;
      this.model.principal = _selected.principal;
      this.model.tenor = _selected.tenor;
      this.model.interest = _selected.interest;
      this.model.installment_amount = _selected.installment_amount;
      this.model.interstod = _selected.interstod;
      this.lkuPinjamanShow = false;
      this.getDataActivityCollector();
    },
    async getDataActivityCollector() {
      const result = await kolektor.collectorActivity(this.model.nasabahkey);
      this.tblData.items = result;
      this.tblData.total = result.length;
    },
    detailImage(item) {
      this.showDetailImage = true;
      this.detailImg = item;
      this.detailImg.center = {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
      };
      this.detailImg.mapTypeId = "terrain";
      this.detailImg.markers = [{}];
      this.detailImg.markers[0].position = {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
      };
    },
    close() {
      router.push("home");
    },
  },
};
</script>
